module.exports = __webpack_public_path__ + "media/images/rank_03-2d2665d57cefb01ebf3db74bd4ee4b7c.png";